import React, { useState, useEffect, useRef } from "react";
import { baseURL } from "../../utils/config";
import {
  AppBar,
  Box,
  CssBaseline,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
  IconButton,
  InputAdornment,
  TextField,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Popover from "@mui/material/Popover";
import { Search as SearchIcon } from "@mui/icons-material";
import Logo from "../../assets/ukllogo.png";
import { ReactComponent as SearchIcon1 } from "../../assets/images/SearchIcon1.svg";
import { ReactComponent as MenuIcon } from "../../assets/images/Icon.svg";
import Arrow1 from "../../assets/images/Vector.svg";
import SearchBar from "material-ui-search-bar";
import "./header-desktop.css";
import { useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Icon } from "@iconify/react/dist/iconify.js";
import MobileBg from "../../assets/images/Hamburger.svg";
import CloseIcon from "@mui/icons-material/Close";

const drawerWidth = 300;

function DrawerAppBar(props) {
  const navigate = useNavigate();

  const location = useLocation();

  // Check if the current path matches any of the routes
  const [companyUpdatesOpen, setCompanyUpdatesOpen] = useState(false); // Track the dropdown open state

  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [showAboutMobile, setShowAboutMobile] = useState(false);
  const [showProductsMobile, setShowProductsMobile] = useState(false);
  const [showSolutionsMobile, setShowSolutionsMobile] = useState(false);
  const [showCompanyUpdatesMobile, setShowCompanyUpdatesMobile] =
    useState(false);
  const [Routes, setRoutes] = useState([]);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [isLoading, setIsLoading] = useState(true); // Initialize loading state
  const [isMenuVisible, setMenuVisible] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredCards, setFilteredCards] = useState([]);
  const [results, setResults] = useState({
    products: [],
    blogs: [],
    solutions: [],
  });

  const menuRef = useRef(null);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/routes?populate=*`);
        setRoutes(response.data.data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
      //  finally {
      //   setIsLoading(false); // Set loading to false after data is fetched
      // }
    };

    getData();
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const handleSearchClick = () => {
    setSearchOpen(!searchOpen);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handlePopoverItemClick = (subroute) => {
    setCompanyUpdatesOpen(false);
    handleClose();
    navigate(subroute);
  };
  const [anchorE2, setAnchorE2] = React.useState(null);
  const handleProuctItemClick = (url, id) => {
    navigate(url, { state: { productId: id } });
  };
  const [anchorE3, setAnchorE3] = React.useState(null);
  const handlePopoverItemClick2 = (subroute) => {
    handleClose(); // Close the popover
    navigate(subroute); // Navigate to the selected subroute
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClick1 = (event) => {
    setAnchorE2(event.currentTarget);
  };
  const handleClick2 = (event) => {
    setAnchorE3(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorE2(null);
    setAnchorE3(null);
  };
  const open = Boolean(anchorEl);
  const open1 = Boolean(anchorE2);
  const open2 = Boolean(anchorE3);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(true);
    }, 2000);

    setIsLoading(false);
    handleClose();

    return () => clearTimeout(timer);
  }, [location.pathname]);
  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{
        backgroundImage: `url(${MobileBg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundColor: "#FFFFFF",
        height: "100dvh",
        marginTop: -4,
      }}
    >
      <Box sx={{ p: 2, mt: -2 }}>
        <a href="/">
          <img src={Logo} style={{ height: 30 }} />
        </a>
      </Box>
      <Divider sx={{ px: 2 }} />
      <List sx={{ px: 2 }}>
        {Routes.filter((item) => item?.attributes?.header).map((item) => (
          <React.Fragment key={item?.attributes?.title}>
            <ListItem sx={{ py: 1.5 }}>
              <ListItemButton
                onClick={() => {
                  navigate(item?.attributes?.url); // Navigate directly for other items
                }}
                sx={{
                  marginRight:
                    item?.attributes?.title === "About Us" ? "-40px" : "0px",
                }}
              >
                <ListItemText
                  primary={item?.attributes?.title}
                  sx={{ fontSize: "20px", textTransform: "uppercase" }}
                />
                {item?.attributes?.title === "About Us" && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowAboutMobile(!showAboutMobile);
                    }}
                    style={{ marginRight: "25px" }}
                  >
                    {showAboutMobile ? (
                      <Icon
                        icon="iconamoon:arrow-up-2"
                        width={"25px"}
                        height={"25px"}
                      />
                    ) : (
                      <Icon
                        icon="iconamoon:arrow-down-2"
                        width={"25px"}
                        height={"25px"}
                      />
                    )}
                  </button>
                )}
                {item?.attributes?.title === "Products" && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowProductsMobile(!showProductsMobile);
                    }}
                    style={{ marginRight: "25px" }}
                  >
                    {showProductsMobile ? (
                      <Icon
                        icon="iconamoon:arrow-up-2"
                        width={"25px"}
                        height={"25px"}
                      />
                    ) : (
                      <Icon
                        icon="iconamoon:arrow-down-2"
                        width={"25px"}
                        height={"25px"}
                      />
                    )}
                  </button>
                )}
                {item?.attributes?.title === "Solutions" && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowSolutionsMobile(!showSolutionsMobile);
                    }}
                    style={{ marginRight: "25px" }}
                  >
                    {showSolutionsMobile ? (
                      <Icon
                        icon="iconamoon:arrow-up-2"
                        width={"25px"}
                        height={"25px"}
                      />
                    ) : (
                      <Icon
                        icon="iconamoon:arrow-down-2"
                        width={"25px"}
                        height={"25px"}
                      />
                    )}
                  </button>
                )}
              </ListItemButton>
            </ListItem>
            <Divider sx={{ px: 2 }} />
            {showAboutMobile && item?.attributes?.title === "About Us" && (
              <Box>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/about-us#company")}
                    // sx={{ textAlign: "center" }}
                  >
                    <ListItemText
                      primary="Our Company"
                      sx={{
                        color:
                          location.pathname === "/about-us#company"
                            ? "#DB1F51"
                            : "#000",
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/about-us#csr")}
                    // sx={{ textAlign: "center" }}
                  >
                    <ListItemText
                      primary="CSR"
                      sx={{
                        color:
                          location.pathname === "/about-us#csr"
                            ? "#DB1F51"
                            : "#000",
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/about-us#services")}
                    // sx={{ textAlign: "center" }}
                  >
                    <ListItemText
                      sx={{
                        color:
                          location.pathname === "/about-us#services"
                            ? "#DB1F51"
                            : "#000",
                      }}
                      primary="Our Manufacturing Resources"
                    />
                  </ListItemButton>
                </ListItem>{" "}
                <ListItem>
                  <ListItemButton onClick={() => navigate("/about-us#rnd")}>
                    <ListItemText
                      primary={"Research, Development & Innovation"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname === "/about-us#rnd"
                              ? "#DB1F51"
                              : "#000",
                          whiteSpace: "pre-wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton>
                    <ListItemText
                      primary="Company Updates"
                      sx={{
                        color:
                          location.pathname === "/about-us/company-updates"
                            ? "#DB1F51"
                            : "#000",
                      }}
                    />
                    <button
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent parent onClick from firing
                        setShowCompanyUpdatesMobile(!showCompanyUpdatesMobile);
                      }}
                    >
                      {" "}
                      {showCompanyUpdatesMobile ? (
                        <Icon
                          icon="iconamoon:arrow-up-2"
                          width={"25px"}
                          height={"25px"}
                        />
                      ) : (
                        <Icon
                          icon="iconamoon:arrow-down-2"
                          width={"25px"}
                          height={"25px"}
                        />
                      )}
                    </button>
                  </ListItemButton>
                </ListItem>
                {showCompanyUpdatesMobile && (
                  <Box>
                    <ListItem>
                      <ListItemButton
                        onClick={() => navigate("/about-us/company-updates")}
                      >
                        <ListItemText
                          primary={
                            <Typography
                              variant="h6"
                              sx={{
                                color:
                                  location.pathname ===
                                  "/about-us/company-updates"
                                    ? "#DB1F51"
                                    : "#000",
                              }}
                            >
                              • Corporate Announcements
                            </Typography>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  </Box>
                )}
              </Box>
            )}
            {showProductsMobile && item?.attributes?.title === "Products" && (
              <Box>
                <ListItem>
                  <ListItemButton
                    onClick={() =>
                      handleProuctItemClick(
                        "/products-listing/piston-valves-and-bellow-seal-valves",
                        1
                      )
                    }
                  >
                    <ListItemText
                      primary={"Piston Valves & Bellow Seal Valves"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname ===
                            "/products-listing/piston-valves-and-bellow-seal-valves"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() =>
                      handleProuctItemClick(
                        "/products-listing/steam-trapping-and-condensate-recovery-solutions",
                        3
                      )
                    }
                  >
                    <ListItemText
                      primary={"Steam Trapping & Condensate Recovery Solutions"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname ===
                            "/products-listing/steam-trapping-and-condensate-recovery-solutions"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() =>
                      handleProuctItemClick(
                        "/products-listing/jointing-sheets-gaskets",
                        4
                      )
                    }
                  >
                    <ListItemText
                      primary={"Jointing Sheets & Gaskets"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname ===
                            "/products-listing/jointing-sheets-gaskets"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() =>
                      handleProuctItemClick(
                        "/products-listing/safety-and-control-valves",
                        5
                      )
                    }
                  >
                    <ListItemText
                      primary={"Safety And Control Valves"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname ===
                            "/products-listing/safety-and-control-valves"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              </Box>
            )}
            {showSolutionsMobile && item?.attributes?.title === "Solutions" && (
              <Box>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/industry/pharma-industry")}
                  >
                    <ListItemText
                      primary={"Pharma Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname === "/industry/pharma-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() =>
                      navigate(
                        "/industry/chemical-petrochemical-plants-industry"
                      )
                    }
                  >
                    <ListItemText
                      primary={"Chemical Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname ===
                            "/industry/chemical-petrochemical-plants-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/industry/textiles-industry")}
                  >
                    <ListItemText
                      primary={"Textile Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname === "/industry/textiles-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() =>
                      navigate("/industry/tyre-manufacturing-industry")
                    }
                  >
                    <ListItemText
                      primary={"Tyre Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname ===
                            "/industry/tyre-manufacturing-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/industry/aerated-block-industry")}
                  >
                    <ListItemText
                      primary={"Aerated Concrete Block"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname ===
                            "/industry/aerated-block-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/industry/brewery-industry")}
                  >
                    <ListItemText
                      primary={"Brewery Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname === "/industry/brewery-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/industry/rice-industry")}
                  >
                    <ListItemText
                      primary={"Rice Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname === "/industry/rice-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/industry/captive-cogen-industry")}
                  >
                    <ListItemText
                      primary={"Captive Cogen Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname ===
                            "/industry/captive-cogen-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/industry/rubber-industry")}
                  >
                    <ListItemText
                      primary={"Rubber Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname === "/industry/rubber-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/industry/soap-industry")}
                  >
                    <ListItemText
                      primary={"Soap Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname === "/industry/soap-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/industry/dairy-industry")}
                  >
                    <ListItemText
                      primary={"Dairy Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname === "/industry/dairy-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/industry/sugar-industry")}
                  >
                    <ListItemText
                      primary={"Sugar Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname === "/industry/sugar-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/industry/edible-oil-industry")}
                  >
                    <ListItemText
                      primary={"Edible Oil Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname ===
                            "/industry/edible-oil-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/industry/fertilizer-industry")}
                  >
                    <ListItemText
                      primary={"Fertilizer Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname ===
                            "/industry/fertilizer-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => navigate("/industry/hotel-industry")}
                  >
                    <ListItemText
                      primary={"Hotel Industry"}
                      primaryTypographyProps={{
                        sx: {
                          color:
                            location.pathname === "/industry/hotel-industry"
                              ? "#DB1F51"
                              : "#000",
                          display: "flex",
                          flexWrap: "wrap",
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              </Box>
            )}
          </React.Fragment>
        ))}

        {isSmallScreen && (
          <ListItem sx={{ py: 1.5 }}>
            <ListItemButton
              onClick={() => {
                navigate("/partner-with-us");
              }}
              sx={{
                // textAlign: "center",
                textTransform: "uppercase",
              }}
            >
              <ListItemText primary="PARTNER WITH US" />
            </ListItemButton>
          </ListItem>
        )}
      </List>
    </Box>
  );

  const handleCompanyUpdatesClick = () => {
    setCompanyUpdatesOpen((prev) => !prev); // Toggle the dropdown
  };

  // const fetchCards = async (searchValue) => {
  //   try {
  //     const response = await axios.get(
  //       `${baseURL}/api/search?query=${searchValue ? searchValue : "how"}`
  //     );
  //     setResults({
  //       products: response.data.products || [],
  //       blogs: response.data.blogs || [],
  //       solutions: response.data.solutions || [],
  //     });

  //     console.log(response.data, "data 234234324s");
  //   } catch (error) {
  //     console.error("Error fetching data: ", error);
  //   }
  // };

  // Fetch data on component mount

  const fetchCards = async (searchValue) => {
    try {
      const response = await axios.get(
        `${baseURL}/api/search?query=${searchValue ? searchValue : "how"}`
      );
      console.log("first======", response.data);
      const newResults = {
        products: response.data.products || [],
        blogs: response.data.blogs || [],
        solutions: response.data.solutions || [],
      };

      setResults(newResults);

      // Filter immediately after setting results
      const allResults = [
        ...newResults.products.map((item) => ({ ...item, type: "products" })),
        ...newResults.blogs.map((item) => ({ ...item, type: "insights" })),
        ...newResults.solutions.map((item) => ({ ...item, type: "solutions" })),
      ];

      if (searchValue) {
        const filtered = allResults.filter((item) =>
          (item.Title || item.title)
            .toLowerCase()
            .includes(searchValue.toLowerCase())
        );
        setFilteredCards(filtered);
      } else {
        setFilteredCards(allResults);
      }

      // console.log(newResults, "data fetched");
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  // useEffect(() => {
  //   fetchCards(searchValue);
  // }, [searchValue]);

  useEffect(() => {
    // Debounce the search to avoid too many API calls
    const debounceTimer = setTimeout(() => {
      fetchCards(searchValue);
    }, 300); // 300ms delay

    return () => clearTimeout(debounceTimer);
  }, [searchValue]);

  // Filter cards based on search input
  // useEffect(() => {
  //   const allResults = [
  //     ...results.products.map((item) => ({ ...item, type: "products" })),
  //     ...results.blogs.map((item) => ({ ...item, type: "insights" })),
  //     ...results.solutions.map((item) => ({ ...item, type: "solutions" })),
  //   ];

  //   console.log(allResults, "data");

  //   if (searchValue) {
  //     const filtered = allResults.filter((item) =>
  //       (item.Title || item.title)
  //         .toLowerCase()
  //         .includes(searchValue.toLowerCase())
  //     );
  //     console.log(filtered, "data 123");

  //     setFilteredCards(filtered);
  //   } else {
  //     setFilteredCards(allResults);
  //   }
  // }, [searchValue, results]);

  // console.log(filteredCards, "data qwerty");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuVisible(false);
      }
    };

    if (isMenuVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuVisible]);

  const handleSearchBarClick = () => {
    if (!isMenuVisible && searchValue) {
      // If menu is closed and there's a search value, fetch and show results
      fetchCards(searchValue);
    }
    setMenuVisible(!isMenuVisible);
  };

  const handleMenuItemClick = (type, slug, item, id) => {
    setSearchValue(item.Title || item.title);
    setMenuVisible(false);
    setSearchOpen(false); // Close mobile search
    navigate(`/${type}/${slug}`, {
      state: { blogId: id },
    });
  };

  const handleSearchInputChange = (value) => {
    setSearchValue(value);
    if (value.trim()) {
      setMenuVisible(true);
    } else {
      setMenuVisible(false);
    }
  };

  return (
    <>
      {isLoading && (
        <Box className="container" sx={{ display: "flex" }}>
          <CssBaseline />
          <AppBar component="nav">
            <Toolbar
              sx={{
                background: "#FFF",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: { xs: "none", lg: "flex" },
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <List sx={{ display: { xs: "none", sm: "flex" }, ml: 2 }}>
                  {Routes.filter((item) => item?.attributes?.header).map(
                    (item) => (
                      <ListItem key={item}>
                        <a
                          href={item?.attributes?.url || "#"}
                          aria-describedby={id}
                          onMouseEnter={(event) => {
                            if (item?.attributes?.title === "About Us") {
                              handleClick(event);
                            } else if (item?.attributes?.title === "Products") {
                              handleClick1(event);
                            } else if (
                              item?.attributes?.title === "Solutions"
                            ) {
                              handleClick2(event);
                            }
                          }}
                          onMouseLeave={handleClose}
                          // onClick={() => {
                          //   if (item?.attributes?.title === "About Us") {
                          //     navigate(item?.attributes?.url);
                          //   } else {
                          //     navigate(item?.attributes?.url);
                          //   }
                          // }}
                          sx={{
                            textAlign: "center",
                            backgroundColor: "transparent",
                          }}
                        >
                          <ListItemText
                            primary={item?.attributes?.title}
                            sx={{
                              fontWeight: 500,
                              fontSize: 13,
                              textTransform: "uppercase",
                            }}
                          />
                        </a>
                      </ListItem>
                    )
                  )}
                </List>
                <a href="/">
                  <img src={Logo} style={{ height: 43, width: "100%" }} />
                </a>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <SearchBar
                    searchIcon={<SearchIcon1 />}
                    style={{
                      width: 223,
                      height: 40,
                      fontSize: 12,
                      marginRight: "46px",
                    }}
                    onClick={handleSearchBarClick}
                    value={searchValue}
                    // onChange={(newValue) => setSearchValue(newValue)}
                    onChange={handleSearchInputChange}
                  />
                  {isMenuVisible && (
                    <div
                      ref={menuRef}
                      style={{
                        position: "absolute",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        width: 223,
                        marginTop: 50,
                        zIndex: 1000,
                        maxHeight: "300px",
                        overflowY: "scroll",
                      }}
                    >
                      {filteredCards.map((item) => (
                        <div
                          key={item.id}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            fontSize: 12,
                          }}
                          onClick={() =>
                            handleMenuItemClick(
                              item.type,
                              item.slug,
                              item.Title || item.title,
                              item.id
                            )
                          }
                        >
                          {item.Title || item.title}
                        </div>
                      ))}
                    </div>
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      position: "relative",
                    }}
                  >
                    <div className="d-flex items-center">
                      <div>
                        <span className="contact-us-text  d-flex">
                          <div className="d-flex">
                            <a
                              className=" header-menu mr-3"
                              href="/partner-with-us"
                            >
                              PARTNER WITH US{" "}
                            </a>
                            <img
                              className="hover:rotate-[-410deg]"
                              src={Arrow1}
                            />
                          </div>
                        </span>
                        <div className="contact-us"></div>
                      </div>
                    </div>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: { xs: "flex", lg: "none" },
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <a href="/">
                  <img src={Logo} style={{ width: 74 }} />
                </a>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: searchOpen ? "flex-end" : "space-between",
                    width: searchOpen ? "80%" : "20%",
                    alignItems: "center",
                    position: "relative",
                  }}
                  className="mobile_search"
                >
                  {searchOpen ? (
                    <>
                      <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search..."
                        sx={{
                          display: { xs: "flex", lg: "none" },
                          width: searchOpen ? 150 : 86,
                          height: 27,
                          marginRight: searchOpen ? "10px" : 0,
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={handleSearchBarClick}>
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        value={searchValue}
                        // onChange={(e) => setSearchValue(e.target.value)}
                        onChange={(e) =>
                          handleSearchInputChange(e.target.value)
                        }
                        onClick={handleSearchBarClick}
                        autoFocus
                      />
                      {isMenuVisible && (
                        <div
                          ref={menuRef}
                          style={{
                            position: "absolute",
                            backgroundColor: "white",
                            border: "1px solid #ccc",
                            width: "223px",
                            // marginTop: 130,
                            zIndex: 1000,
                            maxHeight: "300px",
                            overflowY: "scroll",
                            top: "50px",
                          }}
                        >
                          {filteredCards.map((item) => (
                            <div
                              key={item.id}
                              style={{
                                padding: "8px 12px",
                                cursor: "pointer",
                                fontSize: 12,
                              }}
                              onClick={() =>
                                handleMenuItemClick(
                                  item.type,
                                  item.slug,
                                  item.Title || item.title,
                                  item.id
                                )
                              }
                            >
                              {item.Title || item.title}
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  ) : (
                    <IconButton
                      sx={{
                        display: { xs: "flex", sm: "none" },
                        width: 50,
                        height: 27,
                        marginLeft: searchOpen ? 0 : 0,
                      }}
                      onClick={handleSearchClick}
                    >
                      <SearchIcon />
                    </IconButton>
                  )}
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{ display: { xs: "flex", sm: "none" } }}
                  >
                    <MenuIcon />
                  </IconButton>
                </Box>
              </Box>
            </Toolbar>
          </AppBar>

          <nav>
            <Drawer
              className="container"
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              anchor="right"
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                display: { xs: "block", lg: "none" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                  background: "#fff !important",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  background: "#fff",
                }}
              >
                <IconButton onClick={handleDrawerToggle}>
                  <CloseIcon
                    sx={{ marginRight: "20px", transform: "scale(1.3)", mt: 2 }}
                  />
                </IconButton>
              </Box>

              {drawer}
            </Drawer>
          </nav>

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            BackdropProps={{
              sx: {
                top: 60,
              },
            }}
            PaperProps={{
              sx: {
                backgroundColor: "white !important", // Background color
                boxShadow: 3, // Add shadow for depth
                // borderRadius: 2,
                width: "25%", // Rounded corners
                p: 2,
                marginTop: 1,
                top: "-28px !important", // Padding
              },
              onMouseEnter: () => setAnchorEl(anchorEl), // Keep open when interacting
              onMouseLeave: handleClose, // Close when mouse leaves the popover
            }}
            sx={{
              "& .css-1i0e6f3-MuiModal-root-MuiPopover-root": {
                top: 60,
              },
            }}
            disableEnforceFocus // Disable enforcing focus to allow clicks outside
            disableAutoFocus
            disablePortal // Prevents popover from being rendered outside the DOM hierarchy
            disableScrollLock // Avoids locking the scroll behavior of the page
            disableRestoreFocus // Prevents restoring focus to the anchor element
          >
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/about-us#company"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick("/about-us#company")}
            >
              <a href="/about-us#company">Our Company</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/about-us#csr" ? "#DB1F51" : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick("/about-us#csr")}
            >
              <a href="/about-us#csr">CSR</a>
            </Typography>

            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/about-us#services"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick("/about-us#services")}
            >
              <a href="/about-us#services">Our Manufacturing Resources</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/about-us#rnd" ? "#DB1F51" : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick("/about-us#rnd")}
            >
              <a href="/about-us#rnd">Research, Development & Innovation</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                marginRight: 10,
                display: "flex",
                alignItems: "center",
                color:
                  // location.pathname === "/about-us/company-updates"
                  companyUpdatesOpen ? "#DB1F51" : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick("/about-us/company-updates")}
              onClick={handleCompanyUpdatesClick} // Open the dropdown on click
            >
              Company Updates{" "}
              <button>
                {" "}
                {companyUpdatesOpen ? (
                  <Icon
                    icon="iconamoon:arrow-up-2"
                    width={"25px"}
                    height={"25px"}
                  />
                ) : (
                  <Icon
                    icon="iconamoon:arrow-down-2"
                    width={"25px"}
                    height={"25px"}
                  />
                )}
              </button>
            </Typography>
            {/* Nested Dropdown */}
            {companyUpdatesOpen && (
              <Box
                sx={{
                  ml: 2, // Add margin for nested items
                }}
              >
                <Typography
                  sx={{
                    p: 1,
                    fontSize: 13,
                    color: "#000",
                    ":hover": { color: "#DB1F51", cursor: "pointer" },
                    ":before": {
                      content: "'• '", // Adding bullet point
                    },
                  }}
                  // onClick={() => handlePopoverItemClick("/about-us/company-updates")}
                >
                  <a href="/about-us/company-updates">
                    Corporate Announcements
                  </a>
                </Typography>
              </Box>
            )}
          </Popover>
          <Popover
            id={id}
            open={open1}
            anchorE2={anchorE2}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            BackdropProps={{
              sx: {
                top: 60,
              },
            }}
            PaperProps={{
              sx: {
                backgroundColor: "white !important", // Background color
                boxShadow: 3, // Add shadow for depth
                // borderRadius: 2,
                width: "25%", // Rounded corners
                p: 2,
                marginTop: 1,
                top: "-28px !important", // Padding
                marginLeft: "180px",
              },
              onMouseEnter: () => setAnchorE2(anchorE2), // Keep open when interacting
              onMouseLeave: handleClose, // Close when mouse leaves the popover
            }}
            sx={{
              "& .css-1i0e6f3-MuiModal-root-MuiPopover-root": {
                top: 60,
              },
            }}
            disableEnforceFocus // Disable enforcing focus to allow clicks outside
            disableAutoFocus
            disablePortal // Prevents popover from being rendered outside the DOM hierarchy
            disableScrollLock // Avoids locking the scroll behavior of the page
            disableRestoreFocus // Prevents restoring focus to the anchor element
            //onPointerLeave={handleClose} // Close when mouse leaves
            //onMouseOutCapture={handleClose}
          >
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/main/products/fluid-control-division"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handleProuctItemClick("/products-listing/piston-valves-and-bellow-seal-valves", 1)}
            >
              <Link
                to="/products-listing/piston-valves-and-bellow-seal-valves"
                state={{ productId: 1 }}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Piston Valves & Bellow Seal Valves
              </Link>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname ===
                  "/main/products/fluid-control-division/steam-traps"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handleProuctItemClick("/products-listing/steam-trapping-and-condensate-recovery-solutions", 3)}
            >
              <Link
                to="/products-listing/steam-trapping-and-condensate-recovery-solutions"
                state={{ productId: 3 }}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Steam Trapping & Condensate Recovery Solutions
              </Link>
            </Typography>

            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/main/products/fluid-sealing-division"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handleProuctItemClick("/products-listing/jointing-sheets-gaskets", 4)}
            >
              <Link
                to="/products-listing/jointing-sheets-gaskets"
                state={{ productId: 4 }}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Jointing Sheets & Gaskets
              </Link>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname ===
                  "/main/products/safety-valve-and-control-valve-division"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handleProuctItemClick("/products-listing/safety-and-control-valves", 5)}
            >
              <Link
                to="/products-listing/safety-and-control-valves"
                state={{ productId: 5 }}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Safety And Control Valves
              </Link>
            </Typography>
          </Popover>
          <Popover
            id={id}
            open={open2}
            anchorE3={anchorE3}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            BackdropProps={{
              sx: {
                top: 60,
              },
            }}
            PaperProps={{
              sx: {
                display: "grid",
                gridTemplateColumns: {
                  xs: "repeat(1, 1fr)",
                  sm: "repeat(2, 1fr)",
                },
                backgroundColor: "white !important", // Background color
                boxShadow: 3, // Add shadow for depth
                // borderRadius: 2,
                width: "35%", // Rounded corners
                p: 2,
                marginTop: 1,
                top: "-28px !important", // Padding
                marginLeft: "280px",
              },
              onMouseEnter: () => setAnchorE3(anchorE3), // Keep open when interacting
              onMouseLeave: handleClose, // Close when mouse leaves the popover
            }}
            sx={{
              "& .css-1i0e6f3-MuiModal-root-MuiPopover-root": {
                top: 60,
              },
            }}
            disableEnforceFocus // Disable enforcing focus to allow clicks outside
            disableAutoFocus
            disablePortal // Prevents popover from being rendered outside the DOM hierarchy
            disableScrollLock // Avoids locking the scroll behavior of the page
            disableRestoreFocus // Prevents restoring focus to the anchor element
            //onPointerLeave={handleClose} // Close when mouse leaves
            //onMouseOutCapture={handleClose}
          >
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "industry/pharma-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/pharma-industry")}
            >
              <a href="/industry/pharma-industry">Pharma Industry</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname ===
                  "/industry/chemical-petrochemical-plants-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/chemical-petrochemical-plants-industry")}
            >
              <a href="/industry/chemical-petrochemical-plants-industry">
                Chemical Industry
              </a>
            </Typography>

            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/industry/textiles-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/textiles-industry")}
            >
              <a href="/industry/textiles-industry">Textile Industry</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/industry/tyre-manufacturing-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/tyre-manufacturing-industry")}
            >
              <a href="/industry/tyre-manufacturing-industry">Tyre Industry</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/industry/aerated-block-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/aerated-block-industry")}
            >
              <a href="/industry/aerated-block-industry">
                Aerated Concrete Block
              </a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/industry/brewery-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/brewery-industry")}
            >
              <a href="/industry/brewery-industry">Brewery Industry</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/industry/rice-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/rice-industry")}
            >
              <a href="/industry/rice-industry">Rice Industry</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/industry/captive-cogen-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/captive-cogen-industry")}
            >
              <a href="/industry/captive-cogen-industry">
                Captive Cogen Industry
              </a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/industry/rubber-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/rubber-industry")}
            >
              <a href="/industry/rubber-industry">Rubber Industry</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/industry/soap-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/soap-industry")}
            >
              <a href="/industry/soap-industry">Soap Industry</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/industry/dairy-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/dairy-industry")}
            >
              <a href="/industry/dairy-industry">Dairy Industry</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/industry/sugar-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/sugar-industry")}
            >
              <a href="/industry/sugar-industry">Sugar Industry</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/industry/edible-oil-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/edible-oil-industry")}
            >
              <a href="/industry/edible-oil-industry">Edible Oil Industry</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/industry/fertilizer-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/fertilizer-industry")}
            >
              <a href="/industry/fertilizer-industry">Fertilizer Industry</a>
            </Typography>
            <Typography
              sx={{
                p: 1,
                fontSize: 14,
                color:
                  location.pathname === "/industry/hotel-industry"
                    ? "#DB1F51"
                    : "#000",
                ":hover": {
                  color: "#DB1F51",
                  cursor: "pointer",
                },
              }}
              // onClick={() => handlePopoverItemClick2("/industry/hotel-industry")}
            >
              <a href="/industry/hotel-industry">Hotel Industry</a>
            </Typography>
          </Popover>
        </Box>
      )}
    </>
  );
}

export default DrawerAppBar;
